import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"

const CorpHero = ({ blok }) => {
  // console.log(blok)
  return (
    <section {...storyblokEditable(blok)}>
      <div className="relative h-[550px] overflow-hidden text-white">
        {
          blok.image?.filename &&
          <img
            className="absolute w-full h-[550px] object-cover object-center"
            alt={blok.image.alt}
            loading="lazy" src={`${blok.image.filename}/m/0x1000`}
          />
        }
        <div className="absolute inset-0 bg-gradient-to-t from-gray-600 to-transparent h-[600px]"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center h-[500px]">

          {/* 
          <a href={`/ja`} className="hover:text-gray-300 border-b-2">ホーム</a>
          <img className="my-2 h-[25px]" src="/icons/down-arrow.svg" alt="down"/>
          <p className="">法人のお客様</p>
           */}
          <h1 className="text-4xl md:text-5xl py-6 font-serif max-w-[650px] text-center">{blok.heading}</h1>
          <p className="text-2xl">{blok.subHeading}</p>
        </div>
      </div>
    </section>
  )
}

export default CorpHero